export type MatchedBy = 'serial' | 'email' | 'manual' | 'unmatched';

export interface ShopifyOrderUser {
  id: number;
  email: string;
  name: string | null;
}

export interface ShopifyOrderModel {
  id: number;
  orderNumber: string | null;
  serialNumber: string;
  product: string | null;
  sku: string | null;
  batch: string;
  brand: string | null;
  email: string | null;
  orderedAt: string | null;
  matchedBy: MatchedBy;
  matchedByLabel: string;
  financialStatus: string;
  fulfillmentStatus: string;
  /** Serial-matched links come from physical BLE pairing and cannot be edited. */
  isLocked: boolean;
  user: ShopifyOrderUser | null;
}

export interface ShopifyOrderListModel {
  count: number;
  next: string | null;
  previous: string | null;
  results: ShopifyOrderModel[];
}

export interface ShopifyOrderStats {
  total: number;
  serial: number;
  email: number;
  manual: number;
  unmatched: number;
  unmatched_with_serial: number;
  unmatched_without_serial: number;
}

export interface ShopifyFilterOptions {
  brands: string[];
  skus: string[];
  financial_statuses: string[];
  fulfillment_statuses: string[];
  batches: string[];
  matched_by: { value: MatchedBy; label: string }[];
}

export interface ShopifyOrderQuery {
  page?: number;
  page_size?: number;
  user?: number;
  search?: string;
  brand?: string;
  matched_by?: string;
  has_serial?: 'yes' | 'no';
  sku?: string;
  financial_status?: string;
  fulfillment_status?: string;
  batch?: string;
  date_from?: string;
  date_to?: string;
  sort?: string;
  order?: 'asc' | 'desc';
}

/** Tag colours, kept in one place so the popup and the orders page agree. */
export const MATCH_COLORS: Record<MatchedBy, string> = {
  serial: 'green',
  email: 'blue',
  manual: 'orange',
  unmatched: 'default',
};

/**
 * Short tag labels. The backend's own labels ("Matched on serial") are too wide
 * for a table column and overflowed into the action column; the column heading
 * already supplies the "matched by" context.
 */
export const MATCH_LABELS: Record<MatchedBy, string> = {
  serial: 'Serial',
  email: 'Email',
  manual: 'Manual',
  unmatched: 'Unmatched',
};
